PJQ.views.drawings.DrawingViewer = PJQ.views.photos.PhotoViewer.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'drawing-viewer'),
        elementId: 'dv-outer',
        subTemplates: {
            versionSelect: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'drawing-viewer-version-selector'),
            drawingDetails: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'drawing-viewer-details')
        },
        annotationMenu: {
            type: PJQ.constants.drawings.annotationTypes.INSPECT
        },
        batch: null,
        isAnnotationsEnabled: false,
        onAnnotationChange: null,
        mergeAnnotations: null,
        canEdit: true,
        canAddAnnotations: true,
        shouldCreateCanvas: true,
        noNavigation: false,
        zoomValue: 100,
        snapView: true,
        isEdit: false,
        context: null,
        maxZoom: 500,
        refreshOnResize: true,
        zoomOnMouseWheel: true,
        triggerRoute: false,
        isDisableDownload: false,
        onSortChange: null,
        showSortableViewLink: true,
        keyListeners: [
            {
                which: 27,
                keys: ['Escape', 'Esc'],
                callback: function () {
                    this.destroy();
                }
            },
            {
                which: 37,
                callback: function () {
                    this.prevDrawing();
                }
            },
            {
                which: 13,
                callback: function () {
                    this.nextDrawing();
                }
            },
            {
                which: 66,
                shiftKey: true,
                callback: function () {
                    this.prevDrawing();
                }
            },
            {
                which: 39,
                callback: function () {
                    this.nextDrawing();
                }
            },
            {
                which: 78,
                shiftKey: true,
                callback: function () {
                    this.nextDrawing();
                }
            },
            {
                which: 68,
                shiftKey: true,
                callback: function () {
                    this.downloadFile();
                    $(window).focus();
                }
            },
            {
                which: 73,
                shiftKey: true,
                callback: function () {
                    this.viewDrawingDetails();
                }
            }
        ]
    },
    defaultEvents: {
        'click .iv-canvas,.iv-active-canvas': 'canvasClicked',
        'click .version-select': 'versionSelected',
        'click .btn-prev-drawing': 'prevDrawing',
        'click .btn-next-drawing': 'nextDrawing',
        'click .btn-drawing-details': 'viewDrawingDetails',
        'keyup .input-drawing-name': 'nameChanged',
        'keyup .input-drawing-title': 'titleChanged',
        'keyup .input-tag': 'drawingTagInputChanged',
        'click .btn-add-tag': 'addTag',
        'click .btn-delete-tag': 'deleteTag',
        'click .btn-add-to-current': 'addToCurrentSet',
        'click .btn-remove-from-current': 'removeFromCurrentSet',
        'click .btn-delete-pub-drawing': 'deletePublishedDrawing',
        'mouseup .iv-image-view': 'canvasMouseUp',
        'mousemove .iv-active-canvas': 'canvasMouseMove',
        'mouseleave .iv-active-canvas': 'canvasMouseLeave'
    },
    beforeRender: function () {
        this.options.project = PJQ.app.session.project;
        if (this.options.project != null) {
            this.options.isAnnotationsEnabled = this.options.batch == null;
            if (this.options.project.orderSettings) {
                this.options.isDisableDownload = this.options.project.orderSettings.get('downloadPerFileFee') > 0 && (PJQ.app.session.get('masterUserId') !== this.options.project.get('masterUserId') || this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_ADMIN_PAID_DOWNLOADS));
            } else {
                this.options.isDisableDownload = true;
            }

            if (this.options.versions == null && !this.options.noNavigation) {
                this.options.project.fetchVersions((versions) => {
                    this.options.versions = versions;
                });
            }
        } else {
            this.options.isAnnotationsEnabled = this.options.batch == null;
        }
    },
    renderData: function () {
        return {
            options: this.options,
            showNavigationControls: this.options.versions != null
        };
    },
    initViewer: function () {
        // tracking mechanism for if any model was changed in this viewer session
        this.changed = false;
        this.options.canEditDrawing = this.options.canEdit && (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK_COMPANY) ||
            PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK));

        if (this.options.batch != null) {
            this.options.contextVersion = this.options.batch.version;
        }

        this.renderDrawingSelector();
        this.renderDrawingSort();
        this.setDrawing(this.model, this.options.contextVersion);
    },
    renderDrawingSort: function () {
        if (this.options.batch != null) {
            let $sort = this.$('.sort-container');
            new PJQ.views.drawings.SortDrawings({
                el: $sort,
                batch: this.options.batch,
                contextDrawing: this.model,
                showViewLink: this.options.showSortableViewLink,
                versions: this.options.versions,
                onChange: _.bind(function () {
                    this.changed = true;
                    if (typeof this.options.onSortChange === 'function') {
                        this.options.onSortChange();
                    }
                }, this)
            });
            $sort.removeClass('hidden');
        }
    },
    viewDrawingDetails: function () {
        let $drawingDetails = this.$('.drawing-details'),
            $btnDetails = this.$('.btn-drawing-details');
        if ($drawingDetails.hasClass('hidden')) {
            $btnDetails.addClass('text-primary');
            $drawingDetails.animateCSS('fadeInRight', _.bind(function () {
                this.refresh();
            }, this));
        } else {
            $btnDetails.removeClass('text-primary');
            $drawingDetails.animateCSS('fadeOutRight', _.bind(function () {
                this.refresh();
            }, this));
        }
    },
    addToCurrentSet: function () {
        new PJQ.views.modals.YesNo({
            header: "Add to Current Set",
            body: "Are you sure you want to add this drawing to the current set?  If this sheet number already exists in the current set, it will be replaced by this version.",
            onYes: _.bind(function () {
                this.model.patch(null, {
                    urlOptions: {
                        currentSet: true
                    },
                    success: _.bind(function () {
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                let currentSet = this.options.versions.get(-1);
                                if (currentSet != null) {
                                    let existing = _.findWhere(currentSet.drawings.models, {title: this.model.get('title')});
                                    // remove any drawings that match this drawings title from the current set
                                    currentSet.drawings.remove(existing);
                                    // add this drawing to the current set
                                    currentSet.drawings.add(this.model);
                                }
                                this.renderVersionSelector();
                                this.renderDrawingDetails();
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    removeFromCurrentSet: function () {
        new PJQ.views.modals.YesNo({
            header: "Add to Current Set",
            body: "Are you sure you want to remove this drawing from the current set?",
            onYes: _.bind(function () {
                this.model.patch(null, {
                    urlOptions: {
                        currentSet: false
                    },
                    success: _.bind(function () {
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                let currentSet = this.options.versions.get(-1);
                                if (currentSet != null) {
                                    currentSet.drawings.remove(this.model);
                                }
                                this.renderVersionSelector();
                                this.renderDrawingDetails();
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    deletePublishedDrawing: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'drawings',
                    value: this.model.get('guid')
                },
                {
                    endpoint: 'checkattached'
                }
            ])
        }).get().done(_.bind(function (response) {
            new PJQ.views.modals.YesNo({
                header: "Delete Drawing",
                body: response.attached ? "<b>This drawing is currently attached to at least 1 item on this project.</b> Deleting the drawing will unlink it from all items. Are you sure you want to delete this drawing?" : "Are you sure you want to delete this drawing?",
                onYes: _.bind(function (model, data) {
                    this.model.destroy({
                        success: _.bind(function () {
                            let newCurSetDrawing = null;
                            _.each(this.options.versions.models, function (version) {
                                if (data && data.replacement > 0) {
                                    _.each(version.drawings.models, function (drawing) {
                                        if (drawing.id === data.replacement) {
                                            newCurSetDrawing = drawing;
                                            drawing.set('isCurrentSet', true);
                                        }
                                    }, this);
                                }
                                version.drawings.remove(this.model);
                            }, this);

                            this.renderDrawingSelector();

                            if (newCurSetDrawing != null) {
                                this.setDrawing(newCurSetDrawing);
                            }
                            // then try to go to the next drawing
                            else if (!this.nextDrawing()) {
                                // then try to go to the previous drawing
                                if (!this.prevDrawing()) {
                                    // next try to go to a different drawing in a different version
                                    let newDrawing = _.find(this.options.versions.models, function (version) {
                                        if (_.size(version.drawings.models) > 0) {
                                            return version.drawings.models[0];
                                        }
                                    }, this);
                                    if (newDrawing != null) {
                                        this.setDrawing(newDrawing);
                                    } else {
                                        // we couldnt find any other drawings to go to
                                        // close the viewer
                                        this.destroy();
                                    }
                                }
                            }

                            if (typeof this.options.onDelete === 'function') {
                                this.options.onDelete();
                            }

                            PJQ.notifications.notify.successNotify({
                                message: 'Drawing deleted'
                            });
                        }, this)
                    });
                }, this)
            });
        }, this));
    },
    prevDrawing: function () {
        let item = this.currentImg,
            canvas = this.canvas;
        this.prevItemInfo = {
            position: item.position(),
            size: this.imageDim,
            canvas: canvas
        };
        let contextDrawing = _.find(_.sortBy(this.fullSet, function (drawing) {
            return -drawing.get('sortOrder');
        }), _.bind(function (drawing) {
            return drawing.get('sortOrder') < this.model.get('sortOrder');
        }, this));
        if (contextDrawing != null) {
            this.setDrawing(contextDrawing);
            return true;
        }
        return false;
    },
    nextDrawing: function () {
        let item = this.currentImg,
            canvas = this.canvas;
        this.prevItemInfo = {
            position: item.position(),
            size: this.imageDim,
            canvas: canvas
        };
        let contextDrawing = _.find(_.sortBy(this.fullSet, function (drawing) {
            return drawing.get('sortOrder');
        }), _.bind(function (drawing) {
            return drawing.get('sortOrder') === this.model.get('sortOrder') + 1;
        }, this));

        if (contextDrawing == null) {
            contextDrawing = _.find(_.sortBy(this.fullSet, function (drawing) {
                return drawing.get('sortOrder');
            }), _.bind(function (drawing) {
                return drawing.get('sortOrder') > this.model.get('sortOrder');
            }, this));
        }

        if (contextDrawing != null) {
            this.setDrawing(contextDrawing);
            return true;
        }
        return false;
    },
    renderPagingState: function () {
        let hasPrevious = _.find(_.sortBy(this.fullSet, function (drawing) {
                return -drawing.get('sortOrder');
            }), _.bind(function (drawing) {
                return drawing.get('sortOrder') < this.model.get('sortOrder');
            }, this)) != null,
            hasNext = _.find(_.sortBy(this.fullSet, function (drawing) {
                return drawing.get('sortOrder');
            }), _.bind(function (drawing) {
                return drawing.get('sortOrder') > this.model.get('sortOrder');
            }, this)) != null;
        this.$('.btn-prev-drawing').prop('disabled', !hasPrevious);
        this.$('.btn-next-drawing').prop('disabled', !hasNext);
    },
    versionSelected: function (e) {
        let cid = $(e.currentTarget).data('cid');
        if (cid != null) {
            let ver = this.options.versions.get(cid),
                drawing = ver.drawings.findWhere({name: this.model.get('name')});
            this.setDrawing(drawing, ver);
        }
    },
    setContextVersion: function (version) {
        this.contextVersion = version;
        if (this.options.batch != null) {
            this.fullSet = _.filter(this.options.batch.drawings.models, function (drawing) {
                return !drawing.get('isPublished');
            });
        } else if (this.options.isEdit || this.contextVersion != null) {
            this.fullSet = this.contextVersion.drawings.models;
        } else {
            this.fullSet = this.options.versions.getUniqueDrawings();
        }

        this.renderDrawingSelector();
        this.renderDrawingSort();
    },
    setDrawing: function (drawing, version) {
        this.contextAnnotation = null;
        this.calibration = null;
        this.clearAnnotations();

        if (version != null) {
            this.setContextVersion(version);
        }

        if (this.options.versions != null && this.options.batch == null) {
            if (this.contextVersion == null) {
                // no version was provided, and we dont already have a context version
                // use the current set (if exists), else use the most recent version by issued on
                this.contextVersion = this.options.versions.get(-1);
                if (this.contextVersion == null) {
                    this.contextVersion = _.sortBy(this.options.versions.models, function (version) {
                        return -(new Date(version.get('issuedOn'))).getTime();
                    })[0];
                }
            }

            let fnFindByName = function (ver) {
                return _.find(ver.drawings.models, _.bind(function (verDrawing) {
                    return drawing.get('name') === verDrawing.get('name');
                }, this));
            }

            let contextVerDrawing = fnFindByName(this.contextVersion);
            if (contextVerDrawing != null) {
                this.model = contextVerDrawing;
                this.activeVersion = this.contextVersion;
            } else {
                // we weren't able to find the drawing in the context version
                // find the newest version that was published BEFORE the context version which does contain this drawing
                let contextVerIssued = (new Date(this.contextVersion.get('issuedOn'))).getTime(),
                    prevVersions = _.sortBy(_.filter(this.options.versions.models, _.bind(function (ver) {
                        return ver.id !== -1 && ver.id !== this.contextVersion.id && contextVerIssued >= (new Date(ver.get('issuedOn'))).getTime() && fnFindByName(ver) != null;
                    }, this)), function (version) {
                        return -(new Date(version.get('issuedOn'))).getTime();
                    });
                if (_.size(prevVersions) > 0) {
                    this.activeVersion = prevVersions[0];
                } else {
                    // we werent able to find this drawing in a version older than the context version
                    // find the oldest version we have of this drawing that is not the current set
                    this.activeVersion = _.sortBy(_.filter(this.options.versions.models, function (ver) {
                        return ver.id !== -1 && fnFindByName(ver) != null;
                    }), function (version) {
                        return (new Date(version.get('issuedOn'))).getTime();
                    })[0];
                }
                this.model = fnFindByName(this.activeVersion);
            }
        } else {
            if (version != null) {
                this.contextVersion = version;
                this.activeVersion = version;
            }
            this.model = drawing;
        }
        this.renderDrawing();
        this.renderPagingState();
        return {
            drawing: this.model,
            version: this.activeVersion
        };
    },
    renderDrawing: function () {
        if (this.drawingSelector != null) {
            this.drawingSelector.setValue(this.model.get('name'));
        }

        this.renderDrawingDetails();
        this.renderVersionSelector();
        this.show(this.model.renderUrl(), {
            persistZoom: true
        });

        if (this.options.project != null) {
            this.options.canViewAnnotations = this.options.project.permissions.hasPermission('drawings.canViewAnnotations');
            this.options.isAnnotationsAdmin = this.options.project.permissions.hasPermission('drawings.isAnnotationsAdmin');
        } else if (this.options.forShare) {
            this.options.canViewAnnotations = true;
            this.options.canAddAnnotations = false;
            this.options.isAnnotationsAdmin = false;
        } else {
            this.options.canViewAnnotations = PJQ.app.session.systemPermissions.hasPermission('drawings.canViewAnnotations');
            this.options.isAnnotationsAdmin = PJQ.app.session.systemPermissions.hasPermission('drawings.isAnnotationsAdmin');
        }

        if (this.options.isAnnotationsEnabled && this.options.canViewAnnotations) {
            this.model.fetchAnnotations({
                context: this.options.context,
                contextId: this.options.contextId,
                accessKey: this.options.accessKey
            }, _.bind(function (ann) {
                this.annotations = ann;

                if (this.options.mergeAnnotations != null) {
                    this.annotations.merge(this.options.mergeAnnotations, this.options.contextId);
                }
                this.renderAnnotations();
            }, this));
        } else {
            this.renderAnnotations();
        }
    },
    renderDrawingSelector: function () {
        let $controls = this.$('.drawing-nav-controls');
        if (this.options.noNavigation) {
            $controls.hide();
            return;
        }

        let choices = _.map(_.sortBy(this.fullSet, function (drawing) {
            return drawing.get('sortOrder');
        }), function (drawing) {
            return drawing.get('name');
        });

        if (_.size(choices) === 0) {
            $controls.hide();
        } else if (this.drawingSelector != null) {
            this.drawingSelector.updateChoices(choices);
            this.drawingSelector.setValue(this.model.get('name'));
        } else {
            $controls.show();
            this.drawingSelector = new PJQ.inputs.Selectpicker({
                el: this.$('.select-drawing'),
                hideDisabled: true,
                defaultValue: this.model.get('name'),
                choices: choices,
                onChange: _.bind(function (value) {
                    let selectedDrawing;
                    if (this.contextVersion != null) {
                        selectedDrawing = this.contextVersion.drawings.findWhere({name: value});
                    }
                    if (selectedDrawing == null) {
                        selectedDrawing = _.find(this.fullSet, function (drawing) {
                            return drawing.get('name') === value;
                        });
                    }
                    this.setDrawing(selectedDrawing)
                }, this)
            });
        }
    },
    renderVersionSelector: function () {
        let $versionSelect = this.$('.drawing-versions');
        if (this.options.versions == null || this.options.noNavigation) {
            $versionSelect.empty();
            return;
        }

        if (this.options.batch == null && !this.options.isEdit) {
            let hideIssuedOn;
            if (this.options.project != null) {
                hideIssuedOn = this.options.project.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
            } else {
                hideIssuedOn = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_VERSION_SELECTOR_ISSUED_ON);
            }
            this.renderSubTemplate(false, this.options.subTemplates.versionSelect, $versionSelect, {
                versions: this.options.versions.findVersionsForDrawing(this.model, true),
                contextVersion: this.activeVersion,
                showCurrentSetLabel: true,
                hideIssuedOn: hideIssuedOn,
                currentSet: this.options.versions && this.options.versions.get(-1)
            });
        }
    },
    renderDrawingDetails: function (callback) {
        if (this.options.versions == null) {
            this.$('.btn-drawing-details').addClass('hidden');
            return;
        }

        this.$('.btn-drawing-details').removeClass('hidden');

        let canEditTags = this.options.project != null
            && this.options.project.hasPermission('drawings.isAdmin')
            && (this.options.project.get('masterUserId') === PJQ.app.session.get('masterUserId'));
        this.renderSubTemplate(false, this.options.subTemplates.drawingDetails, this.$('.drawing-details'), {
            model: this.model,
            version: this.activeVersion,
            isEdit: this.options.isEdit,
            currentSet: this.options.versions.get(-1),
            canEditTags: canEditTags,
            canEditDrawing: this.options.canEditDrawing,
            canRemoveCurrentSet: this.options.canEdit
        }, _.bind(function ($details) {
            $details.find('.input-drawing-name,.input-drawing-title').on('keydown', _.bind(function (e) {
                if (e.which === 13) {
                    if (e.shiftKey) {
                        if (this.prevDrawing()) {
                            this.$('.input-drawing-name').focus().select();
                        }
                    } else {
                        if (this.nextDrawing()) {
                            this.$('.input-drawing-name').focus().select();
                        }
                    }
                }
            }, this));
            let tags = [],
                drawingTags = this.model.get('tags');
            _.each(this.options.versions.getDrawingTags(), _.bind(function (tag) {
                if (drawingTags != null && drawingTags.indexOf(tag) === -1 && tags.indexOf(tag) === -1) {
                    tags.push(tag);
                }
            }, this));
            if (_.size(tags) > 0 && canEditTags) {
                new PJQ.inputs.AutocompleteInput({
                    el: $details.find('.input-tag'),
                    source: tags
                });
            }
            if (typeof callback === 'function') {
                callback();
            }
        }, this));
    },
    download: function (e) {
        this.model.download($(e.currentTarget).data('annotations') === true, this.options.context, this.options.contextId);
    },
    nameChanged: function (e) {
        let name = $(e.currentTarget).val();
        this.model.set('name', name);
        this.renderDrawingSelector();
        this.changed = true;
    },
    titleChanged: function (e) {
        let title = $(e.currentTarget).val();
        this.model.set('title', title);
        this.changed = true;
    },
    drawingTagInputChanged: function (e) {
        let tagNameLen = _.size($(e.currentTarget).val().trim());
        if (e.keyCode === 13 && tagNameLen > 0) {
            this.addTag();
            return;
        }

        this.$('.btn-add-tag').prop('disabled', tagNameLen === 0);
        this.changed = true;
    },
    addTag: function () {
        let tagString = this.$('.input-tag').val(),
            tags = [];
        if (_.size(tagString) > 0) {
            _.each(tagString.split(','), function (tag) {
                let tagTrim = tag.trim();
                if (_.size(tagTrim) > 0) {
                    tags.push(tagTrim);
                }
            });
        }
        this.model.addTags(tags, null, _.bind(function () {
            this.renderDrawingDetails(_.bind(function () {
                this.$('.input-tag').focus();
            }, this));
        }, this));
        this.changed = true;
    },
    deleteTag: function (e) {
        let tagName = $(e.currentTarget).closest('.drawing-tag').data('name');
        this.model.deleteTag(tagName, null, _.bind(function () {
            this.renderDrawingDetails();
        }, this));
        this.changed = true;
    },
    deleteDrawing: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this drawing?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        this.changed = true;
                        this.options.versions.fetch({
                            success: _.bind(function () {
                                this.destroy();
                            }, this)
                        });
                    }, this)
                });
            }, this)
        });
    },
    scale: 1,
    mouse: {
        isClicked: false,
        isDrawing: false,
        isDragging: false,
        dragPoint: null,
        isMoving: false,
        moveContext: null,
        start: null,
        current: null,
        isCalibrating: false
    },
    relativeMouse: function (e) {
        let toCanvasX = (e.clientX - this.canvas.x),
            toCanvasY = (e.clientY - this.canvas.y);
        return {
            toCanvas: {
                x: toCanvasX,
                y: toCanvasY
            },
            x: toCanvasX * this.scale,
            y: toCanvasY * this.scale
        };
    },
    setMouseStart: function (e) {
        if (!e) {
            this.mouse.start = null;
            return;
        }
        this.mouse.start = this.relativeMouse(e);
        return this.mouse.start;
    },
    getMouse: function (e) {
        return {
            start: this.mouse.start,
            current: this.relativeMouse(e),
            dragPoint: this.mouse.dragPoint,
            moveContext: this.mouse.moveContext
        };
    },
    isClicked: function () {
        return this.mouse.isClicked === true;
    },
    isDrawing: function () {
        return this.mouse.isDrawing === true;
    },
    canDraw: function () {
        if (this.annotationMenu == null) {
            return false;
        }

        let type = this.annotationMenu.getType();
        return type !== PJQ.constants.drawings.annotationTypes.INSPECT;
    },
    isDragging: function () {
        return this.mouse.isDragging === true;
    },
    isMoving: function () {
        return this.mouse.isMoving === true;
    },
    isCalibrating: function () {
        return this.mouse.isCalibrating === true;
    },
    canEditAnnotations: function () {
        return !this.isDrawing() && this.annotationMenu != null && this.annotationMenu.getType() === PJQ.constants.drawings.annotationTypes.INSPECT;
    },
    startDraw: function (e) {
        this.setMouseStart(e);
        this.mouse.isDrawing = true;
        return this.getMouse(e);
    },
    stopDraw: function () {
        this.mouse.isDrawing = false;
        this.setMouseStart();
    },
    startMove: function (e) {
        this.setMouseStart(e);
        this.mouse.moveContext = {
            start: _.clone(this.contextAnnotation.attributes.start),
            end: _.clone(this.contextAnnotation.attributes.end),
            path: this.contextAnnotation.decodePath()
        }
        this.mouse.isMoving = true;
    },
    stopMove: function () {
        this.mouse.isMoving = false;
        this.moveContext = null;
        this.setMouseStart();
    },
    startDrag: function (dragPoint) {
        this.mouse.isDragging = true;
        this.mouse.dragPoint = dragPoint;
    },
    stopDrag: function () {
        this.mouse.isDragging = false;
        this.mouse.dragPoint = null;
    },
    startCalibrating: function (e) {
        let start = this.setMouseStart(e);
        this.calibration = {
            start: {
                x: start.x,
                y: start.y
            }
        };
        this.mouse.isCalibrating = true;
    },
    stopCalibrating: function () {
        this.mouse.isCalibrating = false;
        this.setMouseStart();
        this.startCalibrationStep(2);
    },
    drawCalibration: function () {
        if (this.activeCtx != null && this.calibration != null && this.calibration.end != null) {
            this.clearCanvas(this.activeCtx);
            let start = {
                    x: this.calibration.start.x / this.scale,
                    y: this.calibration.start.y / this.scale
                },
                end = {
                    x: this.calibration.end.x / this.scale,
                    y: this.calibration.end.y / this.scale
                },
                terminatorHeight = 40 / this.scale,
                terminatorHalf = terminatorHeight / 2;
            this.activeCtx.beginPath();
            this.activeCtx.moveTo(start.x, start.y);
            this.activeCtx.lineTo(end.x, end.y);
            this.activeCtx.moveTo(start.x, start.y - terminatorHalf);
            this.activeCtx.lineTo(start.x, start.y + terminatorHalf);
            this.activeCtx.moveTo(end.x, end.y - terminatorHalf);
            this.activeCtx.lineTo(end.x, end.y + terminatorHalf);
            this.activeCtx.lineWidth = 4 / this.scale;
            this.activeCtx.setLineDash([0]);
            this.activeCtx.strokeStyle = PJQ.constants.colors.RED;
            this.activeCtx.stroke();
        }
    },
    closeCalibration: function () {
        this.$('.calibration-outer').remove();
        this.calibration = null;
        this.drawAnnotations();
    },
    startCalibrationStep: function (step) {
        let stepContent,
            fnAfterRender = null;
        switch (step) {
            case 1:
                stepContent = '<div class="fs-28">Start the calibration by drawing a line on a known length</div>';
                break;
            case 2:
                stepContent = `<div class="fs-24 mb-1">Enter the length of the drawn line</div>
								<div class="input-group">
									<div class="calibration-type mr-3"></div>
									<input class="form-control calibration-imperial calibration-length-feet wd-80p">
									<span class="calibration-imperial ml-1 mr-2 fs-18 d-flex align-items-center">feet</span>
									<input class="form-control calibration-imperial calibration-length-inches wd-80p">
									<span class="calibration-imperial ml-1 fs-18 d-flex align-items-center">inches</span>
									<input class="form-control calibration-metric wd-100p hidden" placeholder="i.e. 10cm, 10m, 10km">
								</div>
								<div class="mt-2">
									<button class="btn btn-primary btn-save-calibration">Save Calibration</button>
									<button class="btn btn-secondary btn-cancel-calibration">Cancel</button>
								</div>`;
                fnAfterRender = _.bind(function () {
                    let calibrationTypeBtn = new PJQ.inputs.ButtonGroup({
                        el: this.$('.calibration-type'),
                        colorInactiveButtons: true,
                        buttons: [{
                            colorClass: 'info',
                            label: 'Imperial',
                            value: PJQ.constants.drawings.scaleTypes.IMPERIAL
                        }, {
                            colorClass: 'info',
                            label: 'Metric',
                            value: PJQ.constants.drawings.scaleTypes.METRIC
                        }],
                        buttonClasses: 'wd-80p',
                        fitHeight: true,
                        defaultValue: PJQ.constants.drawings.scaleTypes.IMPERIAL,
                        onChange: _.bind(function (value) {
                            let $metric = this.$('.calibration-metric'),
                                $imperial = this.$('.calibration-imperial');
                            if (value === PJQ.constants.drawings.scaleTypes.METRIC) {
                                $imperial.addClass('hidden');
                                $metric.removeClass('hidden');
                            } else {
                                $metric.addClass('hidden');
                                $imperial.removeClass('hidden');
                            }
                        }, this)
                    });

                    this.$('.btn-save-calibration').on('click', _.bind(function () {
                        let dx = this.calibration.end.x - this.calibration.start.x,
                            dy = this.calibration.end.y - this.calibration.start.y,
                            d = Math.sqrt(dx * dx + dy * dy),
                            calibrationType = calibrationTypeBtn.getValue(),
                            scale = null;
                        if (calibrationType.toUpperCase() === PJQ.constants.drawings.scaleTypes.IMPERIAL) {
                            let $feet = this.$('.calibration-length-feet'),
                                $inches = this.$('.calibration-length-inches'),
                                feet = parseInt($feet.val()),
                                inches = parseInt($inches.val());
                            if (isNaN(feet)) {
                                feet = 0;
                            }
                            if (isNaN(inches)) {
                                inches = 0;
                            }
                            scale = d / ((feet * 12) + inches);
                        } else {

                        }

                        if (scale > 0) {
                            this.model.updateScale(Math.round(scale), calibrationType, _.bind(function () {
                                PJQ.notifications.notify.successNotify({
                                    message: 'Calibration saved'
                                });
                                this.closeCalibration();
                                if (this.annotationMenu != null) {
                                    let nextType;
                                    if (this.afterCalibrateType != null) {
                                        nextType = this.afterCalibrateType;
                                    } else {
                                        nextType = PJQ.constants.drawings.annotationTypes.INSPECT;
                                    }
                                    this.annotationMenu.setType(nextType);
                                }
                                this.afterCalibrateType = null;
                            }, this));
                        }
                    }, this));
                    this.$('.btn-cancel-calibration').on('click', _.bind(function () {
                        this.closeCalibration();
                    }, this));
                }, this);
                break;
        }
        this.$('.calibration-outer').remove();
        this.imageView.append('<div class="calibration-outer"><div class="calibration-inner">' + stepContent + '</div></div>');

        if (typeof fnAfterRender === 'function') {
            fnAfterRender();
        }
    },
    onMouseDown: function (e) {
        if (this.annotations == null) {
            return;
        }

        this.mouse.isClicked = true;

        let mouse = this.getMouse(e);
        if (this.contextAnnotation != null && !this.isDrawing()) {
            let collidingDragPoint = this.contextAnnotation.getCollidingDragPoint(mouse.current.toCanvas.x, mouse.current.toCanvas.y);
            if (collidingDragPoint != null) {
                this.startDrag(collidingDragPoint);
                return false;
            }
        }

        let fnFindColliding = () => {
            if (this.isMoving() || this.isDrawing() || this.isDragging()) {
                return false;
            }

            let colliding = this.annotations.find((a) => {
                return a.cid !== this.contextAnnotation?.cid && a.collides(mouse.current.x, mouse.current.y);
            });
            if (colliding != null) {
                this.editAnnotation(colliding);
                return true;
            }
            return false;
        }

        if (!this.options.canAddAnnotations) {
            fnFindColliding();
            return false;
        }

        let canEdit = this.canEditAnnotations(),
            annotationType = this.annotationMenu?.getType();
        if (this.annotationMenu != null && annotationType === PJQ.constants.drawings.annotationTypes.CALIBRATION) {
            this.setContextAnnotation(null);
            this.startCalibrating(e);
            return false;
        } else if ((canEdit || this.annotationMenu == null) && annotationType === PJQ.constants.drawings.annotationTypes.INSPECT) {
            if (this.contextAnnotation != null && this.contextAnnotation.canEdit()) {
                if (this.contextAnnotation.collides(mouse.current.x, mouse.current.y)) {
                    //this currently selected annotation collides
                    // loop through colliding items and find the next one
                    setTimeout(() => {
                        if (this.isClicked()) {
                            this.startMove(e);
                            return;
                        }

                        fnFindColliding();
                    }, 100);
                    return !canEdit;
                }
            }

            if (fnFindColliding()) {
                return true;
            }

            if (!this.isMoving() && !this.isDrawing() && !this.isDragging()) {
                setTimeout(_.bind(function () {
                    //if its still clicked, then its moving/dragging/drawing
                    if (!this.isClicked()) {
                        this.cancelEditAnnotation();
                    }
                }, this), 100);
            }
        } else {
            if (this.contextAnnotation != null) {
                this.setContextAnnotation(null);
            }
            if (annotationType !== PJQ.constants.drawings.annotationTypes.INSPECT) {
                this.startDraw(e);
            }
            return false;
        }
    },
    canvasMouseMove: function (e) {
        if (this.isCalibrating()) {
            let mouse = this.getMouse(e);
            this.calibration.end = {
                x: mouse.current.x,
                y: mouse.current.y
            };
            this.drawCalibration(e);
        } else if (this.isDrawing()) {
            let mouse = this.getMouse(e);
            if (this.contextAnnotation == null) {
                let newAnnotation = this.annotations.model({
                    drawingId: this.model.id,
                    type: this.annotationMenu.getType(),
                    color: this.annotationMenu.getColor(),
                    context: this.options.context,
                    contextId: this.options.contextId
                });
                this.setContextAnnotation(newAnnotation);
            }
            this.contextAnnotation.start(mouse.start.x, mouse.start.y);
            this.contextAnnotation.end(mouse.current.x, mouse.current.y);
            this.drawContextAnnotation();
        } else if (this.isDragging()) {
            let mouse = this.getMouse(e);
            this.contextAnnotation.moveDragPoint(mouse.dragPoint, mouse.current.x, mouse.current.y);
            this.drawContextAnnotation();
        } else if (this.isMoving()) {
            let mouse = this.getMouse(e),
                xDiff = mouse.current.x - mouse.start.x,
                yDiff = mouse.current.y - mouse.start.y;
            if (_.size(mouse.moveContext.path) > 0) {
                let newStartX = mouse.moveContext.path[0][0] + xDiff,
                    newStartY = mouse.moveContext.path[0][1] + yDiff;
                this.contextAnnotation.start(newStartX, newStartY);
                this.drawContextAnnotation();
            } else if (mouse.moveContext.start != null && mouse.moveContext.end != null) {
                let newStartX = mouse.moveContext.start.x + xDiff,
                    newStartY = mouse.moveContext.start.y + yDiff,
                    newEndX = mouse.moveContext.end.x + xDiff,
                    newEndY = mouse.moveContext.end.y + yDiff,
                    maxX = this.model.attributes.pixelsX,
                    maxY = this.model.attributes.pixelsY;

                if (newStartX < 0) {
                    newEndX -= newStartX;
                    newStartX = 0;
                } else if (newEndX >= maxX) {
                    newStartX -= newEndX - maxX;
                    newEndX = maxX;
                }

                if (newStartY < 0) {
                    newEndY -= newStartY;
                    newStartY = 0;
                } else if (newEndY >= maxY) {
                    newStartY -= newEndY - maxY;
                    newEndY = maxY;
                }

                this.contextAnnotation.start(newStartX, newStartY);
                this.contextAnnotation.end(newEndX, newEndY);
                this.drawContextAnnotation();
            }
        }
    },
    saveAnnotation: function (annotation) {
        if (typeof this.options.onAnnotationChange === 'function') {
            this.options.onAnnotationChange(annotation);
        } else {
            this.contextAnnotation.beforeSave();
            this.contextAnnotation.isNew() ? this.contextAnnotation.queueSave() : this.contextAnnotation.queuePatch();
        }
    },
    canvasMouseUp: function (e) {
        this.mouse.isClicked = false;
        if (this.isCalibrating()) {
            this.stopCalibrating();
        } else if (this.isDrawing() || this.isDragging() || this.isMoving()) {
            let fnSave = _.bind(function () {
                if (this.contextAnnotation.hasChanged()) {
                    this.saveAnnotation(this.contextAnnotation);
                }
            }, this);
            if (this.isDrawing()) {
                this.stopDraw();
                this.contextAnnotation.normalizeCoords(true);
                this.annotations.add(this.contextAnnotation);
                fnSave();
                this.editAnnotation(this.contextAnnotation);

                if (!this.annotationMenu.enableConsecutive) {
                    this.annotationMenu.setType(PJQ.constants.drawings.annotationTypes.INSPECT);
                }
            } else if (this.isDragging()) {
                this.stopDrag();
                this.contextAnnotation.normalizeCoords();
                fnSave();
            } else if (this.isMoving()) {
                this.stopMove();
                fnSave();
            }
        }
    },
    canvasMouseLeave: function () {
        this.mouse.isClicked = false;
        if (this.isDrawing()) {
            // this.stopDraw();
        }
        if (this.isDragging()) {
            this.stopDrag();
        }
        if (this.isMoving()) {
            this.stopMove();
        }
    },
    updateScale: function () {
        this.scale = this.model.attributes.pixelsX / this.canvas.width;
    },
    afterDimensionChange: function () {
        this.updateScale();
        this.renderAnnotations();
    },
    afterLoad: function () {
        this.renderAnnotations();
    },
    renderAnnotations: function () {
        if (this.options.isAnnotationsEnabled && this.loaded && this.annotations && this.annotations.isFetched) {
            this.clearAnnotations();
            this.renderAnnotationMenu();
            this.drawAnnotations();
        }
    },
    clearCanvas: function (ct) {
        if (ct != null) {
            // ct.clearRect(0, 0, this.canvas.width, this.canvas.height);
            ct.reset();
        }
    },
    clearAnnotations: function () {
        this.clearCanvas(this.ctx);
        this.clearCanvas(this.activeCtx);
    },
    drawAnnotations: function () {
        this.drawContextAnnotation();
        if (this.calibration != null) {
            this.drawCalibration();
        }

        this.clearCanvas(this.ctx);
        _.each(_.filter(this.annotations.models, (annotation) => {
            return !annotation.get('delete') && (this.options.contextId == null || annotation.get('contextId') == null || (annotation.get('contextId') === this.options.contextId && annotation.get('context') === this.options.context));
        }), function (annotation) {
            if (this.contextAnnotation != null && this.contextAnnotation.cid === annotation.cid) {
                return;
            }
            annotation.draw(this.ctx, this.scale, {
                isDrawing: false,
                drawing: this.model
            });
        }, this);
    },
    drawContextAnnotation: function () {
        this.clearCanvas(this.activeCtx);
        if (this.contextAnnotation != null) {
            this.contextAnnotation.draw(this.activeCtx, this.scale, {
                isDrawing: this.isDrawing(),
                drawing: this.model
            });
            if (!this.isDrawing() && (this.options.isAnnotationsAdmin || !this.contextAnnotation.get('isPublished'))) {
                this.contextAnnotation.drawDragPoints(this.activeCtx, this.scale);
            }
        }
    },
    editAnnotation: function (annotation) {
        this.setContextAnnotation(annotation, true);
        this.removeEditView();

        let $iv = this.$('.iv-content'),
            $editOuter = this.$('.annotation-edit-outer');
        if ($editOuter.length === 0) {
            $editOuter = $('<div>', {
                class: 'annotation-edit-outer ht-100 wd-350p position-absolute right-0 top-0 elevation-3'
            });
            $iv.append($editOuter);
        }
        $iv.addClass('annotating');

        this.editAnnotationView = new PJQ.views.drawings.EditAnnotation({
            el: $editOuter,
            model: annotation,
            project: this.options.project,
            context: this.options.context,
            versions: this.options.versions,
            canEdit: this.options.isAnnotationsAdmin || annotation.canEdit(),
            isAdmin: this.options.isAnnotationsAdmin,
            focusText: annotation.isNew() && annotation.get('type') === PJQ.constants.drawings.annotationTypes.TEXT,
            onAttachmentChange: () => {
                this.saveAnnotation(annotation);
            },
            onAnnotationDataChange: () => {
                this.drawContextAnnotation();
                this.saveAnnotation(annotation);
            },
            onShapeChange: () => {
                this.drawContextAnnotation();
                this.saveAnnotation(annotation);
            },
            onPublish: (annotation) => {
                this.publishAnnotation(annotation);
            },
            onDelete: (annotation) => {
                this.deleteAnnotation(annotation);
            },
            onClose: () => {
                this.cancelEditAnnotation();
            },
            onDrawingSelected: (drawing) => {
                this.cancelEditAnnotation();
                this.setDrawing(drawing);
            }
        });
    },
    cancelEditAnnotation() {
        this.setContextAnnotation(null, true);
        this.removeEditView();
    },
    removeEditView: function () {
        if (this.editAnnotationView != null) {
            this.editAnnotationView.remove();
            this.editAnnotationView = null;
            this.$('.iv-content').removeClass('annotating');
        }
    },
    publishAnnotation: function (annotation) {
        if (annotation != null) {
            annotation.set('isPublished', !annotation.get('isPublished'));
            if (typeof this.options.onAnnotationChange === 'function') {
                this.options.onAnnotationChange(annotation);
            } else {
                annotation.publish();
            }
        }
    },
    deleteAnnotation: function (annotation) {
        if (annotation != null) {
            if (typeof this.options.onAnnotationChange === 'function') {
                annotation.set('delete', true);
                this.options.onAnnotationChange(annotation);
            } else {
                this.annotations.remove(annotation);
                annotation.destroy();
                this.cancelEditAnnotation();
            }
        }
    },
    setContextAnnotation: function (annotation = null, redraw = true) {
        let enablePicker = annotation == null || annotation.canEditColor();
        if (this.annotationMenu != null) {
            this.annotationMenu.enableColorPicker(enablePicker);
        }

        if (annotation) {
            this.contextAnnotation = annotation;
            if (this.annotationMenu != null && enablePicker) {
                this.annotationMenu.setColor(this.contextAnnotation.getStrokeColor());
            }
            if (this.$canvas) {
                this.$canvas.css('opacity', '0.5');
            }
        } else {
            this.contextAnnotation = null;
            if (this.$canvas) {
                this.$canvas.css('opacity', 'initial');
            }
        }

        if (redraw) {
            this.drawAnnotations();
        }
    },
    canvasClicked: function () {
        if (this.annotationMenu != null) {
            this.annotationMenu.collapseSubMenus();
        }
    },
    renderAnnotationMenu: function () {
        if (this.annotationMenu != null) {
            this.annotationMenu.remove();
        }

        if (this.options.canAddAnnotations === false) {
            return;
        }

        this.annotationMenu = new PJQ.views.drawings.AnnotationMenu({
            el: this.$('.annotation-menu-outer'),
            type: this.options.annotationMenu.type,
            color: this.options.annotationMenu.color,
            project: this.options.project,
            onColorChange: _.bind(function (color) {
                this.options.annotationMenu.color = color;
                if (this.contextAnnotation != null) {
                    this.contextAnnotation.set('color', color);
                    this.drawContextAnnotation();
                    this.contextAnnotation.isNew() ? this.contextAnnotation.queueSave() : this.contextAnnotation.queuePatch();
                }
            }, this),
            onTypeChange: _.bind(function (type) {
                if (type !== PJQ.constants.drawings.annotationTypes.INSPECT) {
                    this.setContextAnnotation(null, false);
                }

                this.options.annotationMenu.type = type;
                this.drawAnnotations();
                if (this.canDraw()) {
                    this.$activeCanvas.addClass('annotate');
                } else {
                    this.$activeCanvas.removeClass('annotate');
                }

                if (this.model.get('scale') == null && (type === PJQ.constants.drawings.annotationTypes.RULER || type === PJQ.constants.drawings.annotationTypes.AREA_RECT
                    || type === PJQ.constants.drawings.annotationTypes.RULER_FREE_FORM || type === PJQ.constants.drawings.annotationTypes.AREA_FREE_FORM)) {
                    this.afterCalibrateType = type;
                    type = PJQ.constants.drawings.annotationTypes.CALIBRATION;
                    this.annotationMenu.setType(type);
                }

                if (type === PJQ.constants.drawings.annotationTypes.CALIBRATION) {
                    this.startCalibrationStep(1);
                } else {
                    this.closeCalibration();
                }
            }, this)
        });
    },
    onClose: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.changed === true);
        }
    },
});

PJQ.views.drawings.AnnotationMenu = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'annotation-menu'),
        color: PJQ.constants.colors.BLUE,
        onTypeChange: null,
        onColorChange: null,
        enableConsecutive: false
    },
    events: {
        'click .sub-menu-item': 'subMenuItemClicked',
        'click .consecutive-item': 'consecutiveItemClicked',
        'click .color-picker-item': 'colorPickerMenuItemClicked',
        'click .menu-item': 'typeClicked',
        'click .iv-content': 'collapseAnnotationMenu',
    },
    beforeFirstRender: function () {
        this.enableConsecutive = 'true' === PJQ.helpers.cookieHelpers.getCookie(PJQ.constants.cookies.ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS);
        if (this.options.type == null) {
            this.options.type = PJQ.constants.drawings.annotationTypes.INSPECT;
        }
    },
    renderData: function () {
        return {
            enableConsecutive: this.enableConsecutive,
            type: this.getType(),
            color: this.getColor(),
            canViewPunchList: this.options.project.permissions.hasPermission('punchList.canView'),
            canViewActionItems: this.options.project.permissions.hasPermission('actionItems.canView'),
            enableRefs: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DRAWING_ANNOTATION_REFS)
        };
    },
    afterRender: function () {
        this.renderColorPicker();
    },
    renderColorPicker: function () {
        this.colorPicker = new PJQ.colors.SimpleColorPicker(this.$('.color-menu-outer'), {
            color: this.options.color,
            onColorPicked: _.bind(function (color) {
                this.colorClicked(color);
            }, this)
        });
    },
    colorClicked: function (color) {
        this.options.color = color;
        this.$('.active-color').css('background', this.options.color);
        if (typeof this.options.onColorChange === 'function') {
            this.options.onColorChange(this.options.color);
        }
        this.render();
    },
    colorPickerMenuItemClicked: function () {
        if (this.colorPickerEnabled === false) {
            return;
        }

        this.collapseSubMenus();
        this.colorPicker.toggle();
    },
    hideColorPicker: function () {
        if (this.colorPicker != null) {
            this.colorPicker.hide();
        }
    },
    setColor: function (color) {
        this.options.color = color;
        if (this.colorPicker != null) {
            this.colorPicker.setColor(this.options.color);
            this.render();
        }
    },
    getColor: function () {
        return this.options.color;
    },
    typeClicked: function (e) {
        e.stopPropagation();
        let $target = $(e.currentTarget),
            selectedType = $target.data('type');
        if (selectedType != null && selectedType !== this.options.type) {
            this.setType(selectedType);
        } else {
            this.render();
        }
    },
    setType: function (type) {
        this.options.type = type;
        this.render();
        if (typeof this.options.onTypeChange === 'function') {
            this.options.onTypeChange(this.options.type);
        }

        this.enableColorPicker(PJQ.models.drawings.Annotation.prototype.canEditColor(this.options.type));
    },
    getType: function () {
        return this.options.type;
    },
    subMenuItemClicked: function (e) {
        let $target = $(e.currentTarget),
            isActive = $target.hasClass('active');
        this.collapseSubMenus();
        if (!isActive) {
            $target.addClass('active');
        }
    },
    consecutiveItemClicked: function () {
        this.enableConsecutive = !this.enableConsecutive;
        PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.ENABLE_CONSECUTIVE_DRAWING_ANNOTATIONS, this.enableConsecutive.toString());
        this.render();
    },
    collapseSubMenus: function (hideColorPicker = false) {
        this.$('.sub-menu-item').removeClass('active');
        if (hideColorPicker) {
            this.hideColorPicker();
        }
    },
    enableColorPicker: function (enabled) {
        let $colorPicker = this.$('.color-picker-item');
        if (enabled) {
            $colorPicker.removeClass('op-3');
        } else {
            $colorPicker.addClass('op-3');
        }
        this.colorPickerEnabled = enabled;
    }
});
